function i(u) {
  return u.items.reduce(
    (t, r) => {
      const { ticketItems: n } = r;
      return n.forEach((s) => {
        const { ticketId: e } = s;
        e in t ? t[e].push(s) : t[e] = [s];
      }), t;
    },
    {}
  );
}
export {
  i as default
};
